import ROUTES from "../../utils/routes";
import BaseTextButton from "../BaseTextButton";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./style.scss";

export default function NavigateToLoginBtn({ params }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <BaseTextButton
      className="base-login-nav"
      iconStyle="base-login-nav-ic"
      onClick={() =>
        navigate(ROUTES.LOGIN_PAGE, {
          state: { from: ROUTES.REGISTER_PAGE, ...params },
        })
      }
      icon="login"
    >
      {t("login_acc")}
    </BaseTextButton>
  );
}
